<template>
    <div>
        <div class=""></div>
    </div>
</template>

<script>
    export default {
        data(){
            return {

            }
        }
    }
</script>


// WEBPACK FOOTER //
// src/pages/signLabel.vue